<!--
 * @Description: 漏斗图
 * @Author: mdb
 * @Date: 2022-11-28 11:37:00
 * @LastEditTime: 2022-11-29 11:08:48
 * @LastEditors: mdb
-->
<template>
  <div ref="chartRef" :style="{ width, height }" v-show="showECharts"></div>
  <!-- <dc-layout-empty type="nothing" :style="{ width, height }" v-if="!showECharts" /> -->
  <Empty :style="{ width, height }" v-if="!showECharts" />
</template>
  
  <script setup lang="ts">
import { onBeforeMount, ref, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import type { PropType, Ref } from 'vue'
import calc from '@/utils/calc'
import removeTrailingZeros from '@/utils/format'
import { useI18n } from 'vue-i18n'
import Empty from './Empty.vue'
const { t } = useI18n()
const showECharts = ref(false)
const props = defineProps({
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '250px'
  },
  data: {
    type: Array as PropType<any[]>,
    default: () => {
      return []
    }
  }
})
const commonEnum = [
  { seq: 1, name: t('business.wlbfut'), itemStyle: { color: '#3F97FF' } },
  { seq: 2, name: t('business.jt53sf'), itemStyle: { color: '#66ACFF' } },
  { seq: 3, name: t('business.arvbza'), itemStyle: { color: '#8CC1FF' } },
  { seq: 4, name: t('business.qo7nrv'), itemStyle: { color: '#B2D6FF' } },
  { seq: 5, name: t('business.bfmmxs'), itemStyle: { color: '#C2E6FF' } },
  { seq: 6, name: t('business.bfmmxe'), itemStyle: { color: '#D9EAFF' } }
]

const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, false)

const initChart = () => {
  showECharts.value = props.data.length > 0
  if (!showECharts.value) return

  let funnelList = props.data.map((item) => {
    const i = commonEnum.find((ii) => ii.name === item.name)

    return {
      seq: i?.seq || 0,
      l: item.value,
      name: item.name,
      itemStyle: i?.itemStyle
    }
  })
  const total = funnelList.reduce((prev: number, curr: any) => calc.Add(prev, Number(curr.l) || 0), 0)
  funnelList = funnelList
    .sort((a, b) => a.seq - b.seq)
    .map((item) => {
      const result = funnelList.reduce(
        (prev: number, curr: any) => calc.Add(prev, item.seq <= curr.seq && curr.seq !== 6 ? Number(curr.l) || 0 : 0),
        0
      )
      return {
        ...item,
        value: item.seq === 6 ? item.l : result,
        label: {
          show: true,
          position: 'right',
          formatter: () => {
            return `${item.name}  {b|${item.l}}（${removeTrailingZeros(((item.l / total) * 100).toFixed(2))}%）`
          },
          color: '#6E7B91',
          textStyle: {
            rich: {
              b: {
                fontWeight: 'bold',
                fontSize: '16px'
              }
            }
          }
        }
      }
    })
  setOptions({
    tooltip: {
      trigger: 'item',
      formatter: function (params) {
        const item = funnelList[params.dataIndex]
        return `${item.name} ${item.l}`
      }
    },
    // legend: {
    //   // orient: 'vertical',
    //   right: 'right',
    //   bottom: 'center',
    //   icon: 'circle',
    //   left: '75%',
    //   width: 100,
    //   selectedMode: false,
    //   formatter: function (name) {
    //     let data = funnelList
    //     const quality = data.find((item) => item.name === name)?.l
    //     const arr = ['{b|' + name + '}', '{c|' + quality + '}']
    //     return arr.join(' ')
    //   },
    //   textStyle: {
    //     align: 'right',
    //     rich: {
    //       b: {
    //         color: '#6E7B91',
    //         fontSize: '12px'
    //       },
    //       c: {
    //         fontWeight: 'bold',
    //         color: '#6E7B91',
    //         fontSize: '16px'
    //       }
    //     }
    //   }
    // },
    series: [
      {
        type: 'funnel',
        width: '50%',
        // min: 20,
        // max: 100,
        minSize: '10%',
        // maxSize: '150%',
        top: 50,
        // left: '10%',
        bottom: 50,
        sort: 'none',
        label: {
          show: true
          // position: 'right',
          // formatter: '{b} {d}%',
          // color: '#333'
        },
        labelLine: {
          length: 80,
          lineStyle: {
            width: 1,
            type: 'dashed',
            color: '#ccc'
          }
        },
        emphasis: {
          disabled: true
        },
        data: funnelList
      }
    ]
  })
}

watch(
  () => props.data,
  (v) => {
    initChart()
  }
)

onBeforeMount(() => {
  initChart()
})
</script>
<script lang="ts">
export default { name: 'BoardFunnelChart' }
</script>
  
<style scoped></style>
  